import React, {memo, useMemo} from 'react';

// import {FmlxBackdropLoading} from 'fmlx-common-ui';
import {useDispatch, useSelector} from 'react-redux';

import {restartSystem} from '@/businesses/appBusiness';
import Loading from '@/components/loading/Loading';
import useIntlFormat from '@/hooks/useIntlFormat';
import {getMainLoadingPage} from '@/selectors/loadingSelector';

function MainLoadingPage() {
  const {formatMessage} = useIntlFormat();
  const dispatch = useDispatch();
  const {isActive, loadingText, loadingClickEvent, showRestartService, loadingButton1, loadingButton2} =
    useSelector(getMainLoadingPage);

  const memoizedLoadingButton1 = useMemo(() => {
    if (showRestartService)
      return {
        onClick: () => dispatch(restartSystem()),
        id: 'loading-button-restart-service',
        label: formatMessage({id: 'loading.hub.connectionClosed.primaryButton'}),
      };

    return loadingButton1;
  }, [dispatch, formatMessage, loadingButton1, showRestartService]);

  return (
    <Loading
      isActive={isActive}
      loadingText={formatMessage({id: loadingText, defaultMessage: loadingText})}
      loadingClickEvent={loadingClickEvent}
      loadingButton1={memoizedLoadingButton1}
      loadingButton2={loadingButton2}
    />
    // <FmlxBackdropLoading
    //   id="backdrop-loading"
    //   show={show}
    //   description={isIntlFormat ? formatMessage({id: text}) : text}
    //   size="md"
    //   showButton={false}
    // />
  );
}

export default memo(MainLoadingPage);
